var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeadsReleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 2,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 20.81V29.19C35 32 33.71 33.93 31.44 34.66C30.78 34.89 30.02 35 29.19 35H20.81C19.98 35 19.22 34.89 18.56 34.66C16.29 33.93 15 32 15 29.19V20.81C15 17.17 17.17 15 20.81 15H29.19C32.83 15 35 17.17 35 20.81Z",
    fill: "#FCC200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4401 34.6597C30.7801 34.8897 30.0201 34.9998 29.1901 34.9998H20.8101C19.9801 34.9998 19.2201 34.8897 18.5601 34.6597C18.9101 32.0197 21.6701 29.9697 25.0001 29.9697C28.3301 29.9697 31.0901 32.0197 31.4401 34.6597Z",
    fill: "#0E0E0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5799 24.58C28.5799 26.56 26.9799 28.17 24.9999 28.17C23.0199 28.17 21.4199 26.56 21.4199 24.58C21.4199 22.6 23.0199 21 24.9999 21C26.9799 21 28.5799 22.6 28.5799 24.58Z",
    fill: "#0E0E0E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsReleted);
export default __webpack_public_path__ + "static/media/LeadsReleted.fe78cc1382d870f4906c0a7492d99447.svg";
export { ForwardRef as ReactComponent };